// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1PRLf","header":"MergedInvoice_header__28Z13"};